import { useState, useEffect } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import "./wallets.css";
import SetTitle from "../../components/setTitle/SetTitle";
// import IntervalsMenuPaymentPeriod from "../../components/intervalsMenuPaymentPeriod/IntervalsMenuPaymentPeriod";
// import Price from "../../components/price/Price";
import AddPaidWalletDialog from "../../components/crudSql/addPaidWalletDialog/AddPaidWalletDialog";
import PlansDialog from "../../components/crudSql/plansDialog/PlansDialog";
import PaidPlansDialog from "../../components/crudSql/plansDialog/PaidPlansDialog";
import HiddenBlock from "../../components/crudSql/hiddenBlock/HiddenBlock";
import { dateDiffInDays, mysqlDate } from "../../components/common/date";
import { walletShort } from "../../components/common/dataShort";

// const depositWalletsA = {
//   BSC: { BUSD: "0x61d3193433e672df6ea91a77d80c95c9a32b4233" },
// };
import { depositWalletsA } from "../../components/common/wallets";

import Button from "@mui/material/Button";

export default function Wallets(props) {
  // console.log(props);

  SetTitle("Wallets @ DefiWatch.biz");

  const walletAbbr = useSelector((state) => state.settings.walletAbbr);

  const [plans, setPlans] = useState({});
  const [paymentPeriod, setPaymentPeriod] = useState("Monthly");
  const [paymentPeriodMo, setPaymentPeriodMo] = useState(1);

  const moByPeriod = { Monthly: 1, Annually: 12 };
  useEffect(() => {
    // console.log("moByPeriod", paymentPeriod, moByPeriod[paymentPeriod]);
    setPaymentPeriodMo(moByPeriod[paymentPeriod]);
  }, [paymentPeriod]);

  useEffect(() => {
    const getPlans = () => {
      Axios.get(
        process.env.REACT_APP_CRUD_SRV + "/plans"
        // ?auth=" +
        // userAuthWallet +
        // "&cs=" +
        // sha256(userAuthWallet + process.env.REACT_APP_SECRET)
      ).then((res) => {
        // console.log("plans", res.data.response.plans);
        if (res.data?.status == 200) setPlans(res.data.response.plans);
      });
    };

    if (props.userAuthWallet != "") getPlans();
  }, [props.userAuthWallet]);

  function handlePlanUpgrade(wallet, plan, dialog = false) {
    if (!wallet) {
      toast.error("First connect the wallet!");
      return;
    }

    const pricePerPeriod = paymentPeriodMo * plans[plan][paymentPeriodMo];
    const minDeposit = pricePerPeriod - props.smUserBalanceUsd;

    // console.log(
    //   "smUserBalanceUsd",
    //   props.smUserBalanceUsd,
    //   paymentPeriodMo,
    //   pricePerPeriod
    // );
    if (props.smUserBalanceUsd < pricePerPeriod)
      toast.error(
        "Not enough balance. Please deposit minimum " +
          minDeposit +
          " BUSD to DefiWatch.biz wallet " +
          depositWalletsA.BSC.BUSD +
          " from your Metamask wallet " +
          props.userAuthWallet
      );
    else {
      Axios.post(process.env.REACT_APP_CRUD_SRV + "/wallet/updatePlan", {
        wallet,
        plan,
        paymentPeriodMo,
        auth: props.userAuthWallet,
        cs: sha256(
          wallet + plan + props.userAuthWallet + process.env.REACT_APP_SECRET
        ).toString(),
      }).then((r) => {
        if (r.data?.status == 200) {
          console.log(
            "Wallet " + wallet + " has been updated to " + plan + "."
          );

          // Actions After Plan Upgrate

          props.getWallets();

          if (dialog == "plans") {
            setOpenPlans(false);
          }

          if (dialog == "paidPlans") {
            setOpenPaidPlans(false);
          }

          props.getUserBalance();
        } else {
          toast.error(
            "Plan update error. Please wait for some time and try again."
          );
        }

        // e.target.innerHTML =
        //   e.target.innerHTML == "[Active]" ? "[Closed]" : "[Active]";
      });
    }
  }

  // delete
  function handleClickAction(evt) {
    const action = evt.target.getAttribute("data-action");
    const rowJsonStr = evt.target.getAttribute("data-row");
    const row = JSON.parse(rowJsonStr);

    const apiUrl = "/wallet/" + action;
    Axios.post(process.env.REACT_APP_CRUD_SRV + apiUrl, {
      ...row,
      auth: props.userAuthWallet,
      cs: sha256(
        apiUrl +
          rowJsonStr +
          props.userAuthWallet +
          process.env.REACT_APP_SECRET
      ).toString(),
    }).then((r) => {
      if (r.data?.status == 200) {
        toast.success(
          "Wallet " + walletShort(row.wallet) + " has been deleted."
        );
        // if (action == "markAsRead")
        //   toast.info("Alert has been marked as read.");
        // else toast.success("Alert has been deleted.");

        // rm/hide deleted string
        props.setUserWallets(
          props.userWallets.filter((item) => item.wallet != row.wallet)
        );
      } else {
        // toast.error("Alert deletion error. Please wait a while time and try again.");
        toast.error(
          "Wallet " +
            // (action == "markAsRead"
            //   ? " mark as read modification "
            //   : "deletion") +
            "deletion" +
            " error. " +
            process.env.REACT_APP_STR_TRY_AGAIN
        );
      }
    });
    // }
  }

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const [openPlans, setOpenPlans] = useState(false);
  const handleClickOpenPlans = (evt) => {
    setOpenPlans(true);
  };

  const [openPaidPlans, setOpenPaidPlans] = useState(false);
  const handleClickOpenPaidPlans = (evt) => {
    setPaidWallet(evt.target.getAttribute("data-wallet"));
    setPaidWalletExpirationDate(
      evt.target.getAttribute("data-wallet-expiration-date")
    );
    setOpenPaidPlans(true);
  };
  const [paidWallet, setPaidWallet] = useState(false);
  const [paidWalletExpirationDate, setPaidWalletExpirationDate] =
    useState(false);

  return (
    <div className="pageWallets">
      <h3>Authorized Wallet</h3>

      {props.userAuthWallet ? (
        <div className="walletRow">
          <span>
            {walletAbbr
              ? walletShort(props.userAuthWallet)
              : props.userAuthWallet}
          </span>
          <label className="walletBadgeFree">
            {props.authWalletData?.plan}
          </label>
          <label>{props.authWalletData?.dateEnd}</label>
          {/* <Button className="extraSmall">Upgrade</Button> */}
          <Button
            // variant="contained"
            variant={props.authWalletData?.dateEnd ? "outlined" : "contained"}
            className="extraSmall minWidthInitial"
            onClick={handleClickOpenPlans}
            data-wallet={props.userAuthWallet}
          >
            {props.authWalletData?.dateEnd ? "Prolong" : "Upgrade"}
          </Button>
        </div>
      ) : (
        <p>
          DefiWatch.biz will start to auto collect data after the first wallet
          connection. <b>Please connect your wallet through the Metamask.</b>
        </p>
      )}

      {/* <p>Free account has the following limitations:</p> */}

      <PlansDialog
        open={openPlans}
        setOpen={setOpenPlans}
        paidWallet={props.userAuthWallet}
        userAuthWallet={props.userAuthWallet}
        paymentPeriod={paymentPeriod}
        setPaymentPeriod={setPaymentPeriod}
        handlePlanUpgrade={handlePlanUpgrade}
        plans={plans}
      />

      {/* <IntervalsMenuPaymentPeriod
        paymentPeriod={paymentPeriod}
        setPaymentPeriod={setPaymentPeriod}
      /> */}

      <HiddenBlock title="Plans Comparison">
        <table>
          <tbody>
            {/* <tr>
            <th>Plan Comparison</th>
            <th>Basic</th>
            <th>Paid</th>
            <th>Paid Premium</th>
          </tr> */}

            {/* <tr>
            <td></td>
            <th className="price">
              <div className="planTitle">Basic</div>
              <p>
                Track all your investments with the history of the last month
              </p>
              Free
              <div className="benefitsTitle">You are here</div>
            </th>
            <th className="price">
              <div className="planTitle">Pro</div>
              <p>
                Optimal choice for those who invest from time to time with a
                3-year history
              </p>
              {paymentPeriod == "Monthly" ? (
                <Price price={29.9} />
              ) : (
                <Price
                  price={((29.9 * 9) / 12).toFixed(2)}
                  annualDiscount={(29.9 * 3).toFixed(2)}
                />
              )}
              <Button
                variant="contained"
                className="addAdditionalWallet"
                onClick={() => handlePlanUpgrade(props.userAuthWallet, "Pro")}
              >
                Upgrade to Pro
              </Button>
              <div className="benefitsTitle">All the benefits of Pro:</div>
            </th>
            <th className="price">
              <div className="planTitle">Premium</div>
              <p>
                Highest precision and maximum data to capture all possible
                opportunities
              </p>
              {paymentPeriod == "Monthly" ? (
                <Price price={297} />
              ) : (
                <Price
                  price={((297 * 9) / 12).toFixed(2)}
                  annualDiscount={(297 * 3).toFixed(2)}
                />
              )}
              <Button
                variant="contained"
                className="addAdditionalWallet"
                onClick={() =>
                  handlePlanUpgrade(props.userAuthWallet, "Premium")
                }
              >
                Upgrade to Premium
              </Button>
              <div className="benefitsTitle">The complete package, with:</div>
            </th>
          </tr> */}
            <tr>
              <th></th>
              <th>Basic</th>
              <th>Pro</th>
              <th>Premium</th>
            </tr>
            <tr>
              <td>Time between automatic data collection</td>
              <td>3 hours</td>
              <td>1 hour</td>
              <td>15 minutes</td>
            </tr>
            <tr>
              <td>Data shown on charts</td>
              <td>Last month</td>
              <td>3 years</td>
              <td>Whole time</td>
            </tr>
            <tr>
              <td>Alerts</td>
              <td>Notifications</td>
              <td>Notifications + Email</td>
              <td>Notifications + Email (higher priority)</td>
            </tr>
            <tr>
              <td>
                Automatic data collection on all DefiWatch.biz Auto vaults
              </td>
              <td className="tdNo">+</td>
              <td className="tdYes">+</td>
              <td className="tdYes">+</td>
            </tr>
            <tr>
              <td>
                Average time to add missing Auto vaults on your request{" "}
                <span
                  className="help"
                  title="Ahead of the queue of vaults to be added with the most votes"
                >
                  ?
                </span>
              </td>
              <td>The ones with the most votes are added first</td>
              <td>72 hours (1 vault/mo)</td>
              <td>48 hours (3 vaults/mo)</td>
            </tr>
            <tr>
              <td>
                Price of adding subsequent required Auto vaults on your request{" "}
                <span
                  className="help"
                  title="Ahead of the queue of vaults to be added with the most votes"
                >
                  ?
                </span>
              </td>
              <td colSpan={3} style={{ textAlign: "center" }}>
                Addition during 72 hours - $30/vault, 48 hours - $100/vault
              </td>
            </tr>
            <tr>
              <td>
                The ability to add Manual vaults and data for further display in
                stats
              </td>
              <td className="tdNo">+</td>
              <td className="tdYes">+</td>
              <td className="tdYes">+</td>
            </tr>
            <tr>
              <td>Raw data export</td>
              <td className="tdNo">-</td>
              <td className="tdYes">+</td>
              <td className="tdYes">+</td>
            </tr>
          </tbody>
        </table>
      </HiddenBlock>

      <br />
      <div className="paidWalletsHeader">
        <h3>Unauthorized Wallets</h3>

        {props.userAuthWallet && (
          <Button
            variant="outlined"
            className="extraSmall addAdditionalWallet"
            onClick={handleClickOpen}
          >
            Add Unauthorized Wallet to Monitor
          </Button>
        )}
      </div>

      <AddPaidWalletDialog
        open={open}
        setOpen={setOpen}
        getWallets={props.getWallets}
        userAuthWallet={props.userAuthWallet}
      />

      <p className="paidWalletsP">
        Additional unauthorized wallets does not require proof of ownership via
        Metamask and allow you to track other people's wallets, such as whales
        or famous people whose investments you want to follow in real time.
      </p>

      {/* {props.userWallets[0]?.wallet} */}
      {props.userWallets
        .filter((row) => row.wallet != props.userAuthWallet)
        .map((row) => {
          let dateDiff;
          if (row.dateEnd)
            dateDiff = dateDiffInDays(new Date(), new Date(row.dateEnd));

          return (
            <div
              key={row.wallet}
              className={
                "walletRow" +
                (row.plan ? " walletRowActive" : " walletRowNotActive") +
                (row.dateEnd && dateDiff < 0
                  ? " walletExpired"
                  : row.dateEnd && dateDiff < 11
                  ? " walletExpires"
                  : "")
              }
            >
              <span>{walletAbbr ? walletShort(row.wallet) : row.wallet}</span>
              <label
                className={row.plan ? "walletBadgePaid" : "walletBadgeNotPaid"}
              >
                {row.plan ? row.plan : "Not Active"}
              </label>

              <label>
                {row.firstDataCollectionDt && (
                  <>
                    {mysqlDate(row.firstDataCollectionDt) + " - "}
                    <span className="walletDateEnd">{row.dateEnd}</span>
                  </>
                )}
              </label>

              <label className="walletExpirationTerm">
                {row.dateEnd && dateDiff < 0
                  ? "Expired " + Math.abs(dateDiff) + " days ago"
                  : row.dateEnd && dateDiff < 11
                  ? "Expires " +
                    (dateDiff === 0 ? " today" : "within " + dateDiff + " days")
                  : ""}
              </label>

              <Button
                variant={row.dateEnd ? "outlined" : "contained"}
                className="extraSmall"
                onClick={handleClickOpenPaidPlans}
                data-wallet={row.wallet}
                data-wallet-expiration-date={row.dateEnd}
                color={row.dateEnd ? "success" : "primary"}
              >
                {row.dateEnd ? "Prolong" : "Activate"}
              </Button>

              {row.dateEnd === null && (
                // <Button
                //   variant="outlined"
                //   color="error"
                <span
                  className="linkDelete"
                  onClick={handleClickAction}
                  data-action="delete"
                  data-row={JSON.stringify({ wallet: row.wallet })}
                  // color={row.dateEnd ? "success" : "primary"}
                >
                  Delete
                </span>
                // </Button>
              )}
            </div>
          );
        })}

      <PaidPlansDialog
        open={openPaidPlans}
        setOpen={setOpenPaidPlans}
        paidWallet={paidWallet}
        paidWalletExpirationDate={paidWalletExpirationDate}
        userAuthWallet={props.userAuthWallet}
        paymentPeriod={paymentPeriod}
        setPaymentPeriod={setPaymentPeriod}
        handlePlanUpgrade={handlePlanUpgrade}
      />
    </div>
  );
}
